import {Component} from "../interface/component";
require('slick-carousel/slick/slick.min');

export class CarouselComponent implements Component {
    private $root:JQuery;
    private $scrollNext: JQuery;
    private $scrollPrev: JQuery;

    constructor(elem:HTMLElement) {
        this.$root = $(elem);
    }

    private bindUI = () => {
        this.$scrollNext      = this.$root.parent().next().find('.js-carousel-scroll-right');
        this.$scrollPrev      = this.$root.parent().next().find('.js-carousel-scroll-left');
    };

    init() {
        this.bindUI();
        this.$root.slick({
            dots: false,
            arrows: true,
            infinite: true,
            nextArrow: this.$scrollNext,
            prevArrow: this.$scrollPrev,
            speed: 500,
            fade: true,
            cssEase: 'linear',
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        arrows: false,
                    }
                }
            ]
        });
    }
}
